module.exports = __webpack_public_path__ + "img/different.c93908e2.jpg";